export default __webpack_public_path__ + "081bf99bac4cca4c3b3454b2a098f454.png";